import * as React from 'react';
import { StyleSheet, Platform, View } from 'react-native';
import { Button, Paragraph, Dialog, Portal } from 'react-native-paper';
import Colors from '../constants/Colors';
import CS from '../constants/Styles';

const Alert = (props) => {

  // React.useEffect(() => {

  // }, [props.options.visible]);

  const hideDialog = () => props.setOptions({ visible: false });
  const isToolTip = props.options.isToolTip === undefined ? false : props.options.isToolTip;

  const buttons = props.options.buttons || (isToolTip ? [] : [{
    text: 'Ok',
    onPress: () => props.setOptions({ visible: false })
  },]);
  const dismissable = props.options.buttons === undefined || props.options.dismissable ? true : false;

  const onPress = (b) => {
    if(typeof b.onPress === 'function'){
      b.onPress();
    }
    props.setOptions({ visible: false });
  }

  const labelStyle = (style) => {
    if(style === 'destructive'){
      return {
        fontWeight: 'bold',
        color: 'red',
      }
    }
    if(style === 'cancel'){
      return {
        fontWeight: 'bold',
        color: Colors.mediumGrey,
      }
    }
    if(style === 'accept'){
      return {
        fontWeight: 'bold',
        color: Colors.green,
      }
    }
  }

  const dialogStyle = () => {
    if(isToolTip){
      return {
        backgroundColor: Colors.blue,
      }
    }
    return {};
  }

  const content = () => {
    if(isToolTip){
      return (
        <Dialog.Content style={[styles.content, { marginTop: props.options.title ? 0 : 10 }]}>
          {props.options.message.map((m, i) => { return (<Paragraph style={[styles.paragraph, CS.lightBlueText, { marginBottom: i + 1 !== props.options.message.length ? 10 : 0, }]} key={i}>{m}</Paragraph>); })}
        </Dialog.Content>
      );
    }
    return (
      <Dialog.Content style={[styles.content, { marginTop: props.options.title ? 0 : 10 }]}>
        <Paragraph style={styles.paragraph}>{props.options.message}</Paragraph>
      </Dialog.Content>
    )
  }

  return (
    <Portal>
      {props.options.visible &&
      <View style={styles.wrapper}>
        <Dialog visible={props.options.visible} onDismiss={hideDialog} dismissable={dismissable} style={[styles.dialog, dialogStyle()]}>
          {props.options.title ?
          <Dialog.Title style={styles.title}>{props.options.title}</Dialog.Title>
          : null
          }
          {content()}
          {/* {buttons.length > 0 && */}
          <Dialog.Actions style={styles.actions}>
            {buttons.map((b,i) => {
              // return <Button key={i} onPress={b.onPress} color='#147EFB' style={styles.button} labelStyle={styles.buttonLabel}>{b.text}</Button>
              return <Button key={i} onPress={() => { onPress(b) }} color='#147EFB' style={styles.button} labelStyle={[styles.buttonLabel, labelStyle(b.style)]}>{b.text}</Button>
            })}
          </Dialog.Actions>
          {/* } */}
        </Dialog>
      </View>}
    </Portal>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: 'rgba(0,0,0,0.65)',
    width: '100%',
    height: '100%',
    position: 'fixed',
    top:0,
    left:0,
  },
  dialog: {
    backgroundColor: 'white',
    minWidth: 300,
    borderRadius: 10,
    ...Platform.select({
      web: {
        maxWidth: 768,
        alignSelf: 'center',
      }
    })
  },
  title: {
    textAlign: 'center',
    // backgroundColor: 'purple',
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 10,
    marginRight: 10,
    color: 'black',
    // fontSize: 18,
    // fontSize: 20,
  },
  content: {
    // backgroundColor: 'pink',
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 10,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
  },
  paragraph: {
    // backgroundColor: 'red',
    textAlign: 'center',
    marginTop: 0,
    marginBottom: 0,
    fontSize: 18,
    color: 'black',
  },
  actions: {
    flexDirection: 'column',
    justifyContent: 'center',
    // backgroundColor: 'orange',
    margin: 0,
    padding: 0,
  },
  button: {
    width: '100%',
    marginTop: 0,
    borderTopWidth: 1,
    // borderTopColor: Colors.lightBlue2,
    borderTopColor: '#f1f1f1',
  },
  buttonLabel: {
    paddingVertical: 7,
    fontSize: 17,
  }
})

export default Alert;